import { useState, useEffect } from "react";
import ButtonClose from "../utilities/buttonClose";


function ResourceImage(props) {

  // Define variables
  const[modal, setModal] = useState(null);
  const imageUrl = props.imageUrl;


  // Component load actions
  useEffect(() => {

    function handleEscape(event) {
      if (event.key === 'Escape') {
        closeModal();
      };
    }

    window.addEventListener('keydown', handleEscape);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('keydown', handleEscape);
    };
  }, []);


  // Define functions
  function expandImage() {
    setModal(
      <div class='modal-wrapper'>
        <div class='modal-container image-zoom'>
          <div class='flex-row'>
            <span>&nbsp;</span>
            <ButtonClose closeAction={closeModal} />
          </div>
          <div class='flex-column image-zoom-container'>
            <img src={imageUrl} />
          </div>
        </div>
      </div>
    );
  }

  function closeModal() {
    setModal(null);
  }


  return (
    <>
      {modal}
      <button onClick={() => expandImage()}>
        <img src={imageUrl} />
      </button>
    </>
  );
}

export default ResourceImage;